// eslint-disable-next-line import/prefer-default-export
export const TRACK_GIFTS_SEGMENT_SOURCE = 'gift tracker';
